import cacheLs from "../cacheLs"

export default {
  addUniversity (state, data) {
    state.selectedUniversity = { ...data }
    cacheLs.set_university(data)
  }
}
